var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["setCompareProductsError"] = "setCompareProductsError";
  ActionType2["setAnnouncerText"] = "setAnnouncerText";
  return ActionType2;
})(ActionType || {});
export {
  ActionType
};
